import { StarterKit } from './starter-kit.js'

export type { StarterKitOptions } from './starter-kit.js'
export * from './starter-kit.js'

export default StarterKit
